import useResourceValue from '@composables/useResourceValue.js'
import { MOD_VIEW_ROUTE } from '@config/routeNames.js'
import i18n from '@plugins/localisation.js'
import { Settings } from '@config/game.js'

export const schema = {
  config: [
    (item) => ({
      label: 'name',
      key: 'name',
      cellClass: 'tw-text-left',
      type: 'content',
      to: item.local
        ? null
        : (_item) => ({
            name: MOD_VIEW_ROUTE,
            params: { mod: _item.name_id },
          }),
    }),
    {
      label: 'filesize',
      format: 'size',
      lowOpacity: true,
      type: 'string',
      key: 'modfile.filesize',
      cellClass: 'tw-hidden xl:tw-table-cell tw-text-left',
      sort: {
        direction: 'desc',
      },
    },
    {
      label: 'added',
      key: 'date_live',
      type: 'string',
      format: 'time',
      lowOpacity: true,
      fallback: '-',
      cellClass: 'tw-hidden lg:tw-table-cell tw-text-left',
      sort: {
        direction: 'desc',
      },
    },
    {
      label: 'updated',
      key: 'date_updated',
      type: 'string',
      format: 'time',
      lowOpacity: true,
      fallback: '-',
      cellClass: 'tw-hidden xl:tw-table-cell tw-text-left',
      sort: {
        direction: 'desc',
      },
    },
    {
      label: 'downloads',
      format: 'number',
      lowOpacity: true,
      type: 'string',
      key: 'stats.downloads_total',
      cellClass: 'tw-text-left',
      sort: {
        key: 'downloads_total',
        alias: 'stats.downloads_total',
        direction: 'desc',
      },
    },
    {
      label: 'subscribers',
      format: 'number',
      lowOpacity: true,
      type: 'string',
      key: 'stats.subscribers_total',
      cellClass: 'tw-text-left',
      sort: {
        key: 'subscribers_total',
        alias: 'stats.subscribers_total',
        direction: 'desc',
      },
    },
    {
      label: 'rating',
      format: 'number',
      lowOpacity: true,
      type: 'string',
      key: 'stats.ratings_total',
      cellClass: 'tw-text-left',
      sort: {
        key: 'ratings_total',
        alias: 'stats.ratings_total',
        direction: 'desc',
      },
    },
  ],
  defaultSort: 'date_updated',
}

const actions = {
  type: 'group',
  cellClass: 'tw-text-right',
  actionCell: true,
  sortable: false,
  group: [],
}

if (Settings.value.showActivateButtons) {
  actions.group.push((item) => ({
    type: 'action',
    attrs: {
      class: 'tw-uppercase lg:tw-min-w-25',
      primary: !item.active,
      active: item.active,
      disabled: item.disabled || item.unsubscribed,
    },
    mobileIcon: item.active ? 'times' : 'check',
    tooltip: item.disabled
      ? i18n.global.t('local_mod_disabled', {
          ugc: useResourceValue().ugcName(null, true, true).value,
          dependencies: item.missing_dependencies?.join(', '),
        })
      : item.active
        ? i18n.global.t('deactivate')
        : i18n.global.t('activate'),
    text: item.active ? i18n.global.t('deactivate') : i18n.global.t('activate'),
    onClick: 'toggleActive',
  }))
}

if (Settings.value.allowSubscribing) {
  actions.group.push((item) => ({
    type: 'action',
    attrs: {
      class: 'tw-uppercase',
      disabled: item.local,
      primary: item.unsubscribed,
      active: !item.unsubscribed,
    },
    mobileIcon: item.unsubscribed ? 'redo-alt' : 'times',
    tooltip: item.local
      ? i18n.global.t('locally_installed')
      : item.unsubscribed
        ? i18n.global.t('resubscribe')
        : i18n.global.t('unsubscribe'),
    text: item.local
      ? i18n.global.t('locally_installed')
      : item.unsubscribed
        ? i18n.global.t('resubscribe')
        : i18n.global.t('unsubscribe'),
    onClick: 'toggleSubscribe',
  }))
}

if (actions.group.length) {
  schema.config.push(actions)
}
